export const isIE = () => { // 判断IE11以下的浏览器（不包括IE11）
  if (window.navigator.userAgent.indexOf("MSIE") >= 1) return true;
  else return false;
}

// 是否为mac系统（包含iphone手机
export const isMac = () => /macintosh|mac os x/i.test(navigator.userAgent)

export const getDetailRecord = (history, pathname) => {
  const { utils_tool } = require('@/tool')
  const { Session } = utils_tool
  const pathnameArr = pathname.split('/')

  let detailInfo = ''
  const sessionName = pathnameArr[1] + '-' + pathnameArr[pathnameArr.length - 1] + 'Record'
  if (history.location && history.location.pathname === pathname) {
    if (history.location && history.location.record) {
      detailInfo = history.location.record || {}
      Session.add(sessionName, detailInfo)
    } else {
      detailInfo = Session.get(sessionName) || {}
    }
  }
  return detailInfo
}


// 受众组件数据格式化
export const formatAuth = (value = {}) => {
  const _value = {}
  if(value.groupId) {
    if(Array.isArray(value.groupId)) {
      _value.groupId = value.groupId.map(val => val.id).toString()
    }else if(Object.prototype.toString.call(value.groupId) === "[object Object]") {
      _value.groupId = value.groupId.id
    } else{
      console.error('受众字段类型错误: ', value.groupId)
    }
  } else {
    _value.orgIds = value.orgIds && value.orgIds.length ? value.orgIds.map(val => val.id) : []
    _value.personIds = value.personIds && value.personIds.length ? value.personIds.map(val => val.id) : []
    _value.positionCategoryIds = value.positionCategoryIds && value.positionCategoryIds.length ? value.positionCategoryIds.map(val => val.id) : []
    _value.positionIds = value.positionIds && value.positionIds.length ? value.positionIds.map(val => val.id) : []
  }
  return _value
}

// 封装doAction
export function request(path, apiParams, key) {
  const _key = key || path.replace(/\//i, "@");
  this.doAction({ path, payload: { key: _key, apiParams } });
}


// 数字转字母
export function optimizedNumberToLetterPair(number) {
  let columnName = '';
  while (number > 0) {
    // 计算余数并将它转换为字母
    let ch = String.fromCharCode('A'.charCodeAt(0) + (number - 1) % 26);
    columnName = ch + columnName;
    // 更新剩余要转换的数字
    number = Math.floor((number - 1) / 26);
  }

  return columnName;
}
